import { FC } from 'react';

import Image from './image.svg';

export const Logo: FC = () => <img src={Image} alt="logo" />;
